import React, { Suspense } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

const CustomEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/HandsFolded'),
);
const RateOneEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/Smiley'),
);
const RateTwoEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/HandsRaised'),
);
const RateThreeEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/HeartEyes'),
);
const RateFourEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/StarEyes'),
);
const RateFiveEmoji = React.lazy(
  () => import('../../../../components/icons/emojis/HeadExplosion'),
);

const EMOJI_DURATION = 800;

const useStyles = makeStyles((theme: Theme) => ({
  emojiHolder: {
    position: 'relative',
    '& > svg': {
      position: 'absolute',
      right: theme.spacing(1),
      top: -1,
      zIndex: theme.zIndex.tooltip,
    },
  },
  emojiExpand: {
    animation: `$emojiExpandAnim ${EMOJI_DURATION}ms`,
  },
  emojiRotate: {
    animationName: `$emojiExpandAnim, $emojiRotateAnim `,
    animationDuration: `${EMOJI_DURATION}ms`,
  },
  '@keyframes emojiExpandAnim': {
    '0%': {
      height: 24,
      width: 24,
    },
    '33%': {
      height: 60,
      width: 60,
    },
    '66%': {
      height: 20,
      width: 20,
    },
    '100%': {
      height: 24,
      width: 24,
    },
  },
  '@keyframes emojiRotateAnim': {
    '33%': {
      transform: 'rotate(-30deg)',
    },
    '66%': {
      transform: 'rotate(15deg)',
    },
    '100%': {
      transform: 'rotate(0)',
    },
  },
}));

type Props = {
  hasCustomTip: boolean;
  percentageTip: number;
  tippingOptions: number[];
};

export function TipEmoji(props: Props): JSX.Element {
  const classes = useStyles();

  const { hasCustomTip, percentageTip, tippingOptions } = props;

  const renderEmoji = (): JSX.Element => {
    if (percentageTip === 0) {
      return null;
    }

    if (hasCustomTip) {
      return (
        <Suspense fallback={<div />}>
          <CustomEmoji
            className={classes.emojiExpand}
            testId="tip-emoji-custom"
          />
        </Suspense>
      );
    }

    const selectedTipIndex = tippingOptions.findIndex(
      (option) => option === percentageTip,
    );

    switch (selectedTipIndex) {
      case 0:
        return (
          <Suspense fallback={<div />}>
            <RateOneEmoji
              className={classes.emojiRotate}
              testId="tip-emoji-one"
            />
          </Suspense>
        );
      case 1:
        return (
          <Suspense fallback={<div />}>
            <RateTwoEmoji
              className={classes.emojiExpand}
              testId="tip-emoji-two"
            />
          </Suspense>
        );
      case 2:
        return (
          <Suspense fallback={<div />}>
            <RateThreeEmoji
              className={classes.emojiRotate}
              testId="tip-emoji-three"
            />
          </Suspense>
        );
      case 3:
        return (
          <Suspense fallback={<div />}>
            <RateFourEmoji
              className={classes.emojiRotate}
              testId="tip-emoji-four"
            />
          </Suspense>
        );
      case 4:
        return (
          <Suspense fallback={<div />}>
            <RateFiveEmoji
              className={classes.emojiExpand}
              testId="tip-emoji-five"
            />
          </Suspense>
        );
      default:
        return null;
    }
  };

  return <div className={classes.emojiHolder}>{renderEmoji()}</div>;
}
